import React from "react";
import AppBar from "../app-bar/app-bar";
import PharmacyProfileManagement from "../management-profile/pharmacy-management";
import DistributorManagement from "../management-profile/distributor-management";
import AdminManagement from "../management-profile/admin-management";
import {useUser} from "../providers/user-context";
import {Box} from "@mui/material";
import {APP_BAR_HEIGHT} from "../components/common/app-layout";

function Welcome({navOpen, toggleNav}) {
    const {userFullName, tenantName, tenantType, tenantId, userIdentity} = useUser();
    return (
        <Box sx={{display: "flex", pt: APP_BAR_HEIGHT, minHeight: "100dvh", bgcolor: "#f5f7fa", boxSizing: "border-box"}}>
            <AppBar userFullName={userFullName} tenantName={tenantName} type={tenantType} navOpen={navOpen} toggleNav={toggleNav}/>
            {tenantType === "PHARMACY" ?
                <PharmacyProfileManagement navOpen={navOpen} tenantId={tenantId} tenantName={tenantName} tenantType={tenantType}/> :
                tenantType === "IMPORTER" ?
                    <DistributorManagement navOpen={navOpen} tenantId={tenantId} tenantName={tenantName} tenantType={tenantType} userIdentity={userIdentity}/> :
                    <AdminManagement navOpen={navOpen} tenantId={tenantId} tenantName={tenantName} tenantType={tenantType}/>
            }
        </Box>
    );
}
export default Welcome;
